import { setAnimationPreferenceMutator } from '../mutators/setAnimationPreferenceMutator';
import { getStore } from '../store/Store';
import type { MailLayoutOptions } from 'owa-outlook-service-option-store';
import { lazyCreateOrUpdateOptionsForFeature, isOptionsLoaded } from 'owa-outlook-service-options';
import {
    type AnimationPreference,
    getOptionsForFeature,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-option-store';
import { setShouldAnimateMutator } from '../mutators/setShouldAnimateMutator';

const query = '(prefers-reduced-motion: no-preference)';
const mediaQueryList = window.matchMedia(query);

export function setAnimationPreference(animationPreference: AnimationPreference): void {
    // Get existing settings on server
    const userOptions = getOptionsForFeature<MailLayoutOptions>(OwsOptionsFeatureType.MailLayout);

    // Update settings on server if the options aren't loaded or the animation preference is different
    if (!isOptionsLoaded() || userOptions.animationPreference != animationPreference) {
        lazyCreateOrUpdateOptionsForFeature.importAndExecute(OwsOptionsFeatureType.MailLayout, {
            ...userOptions,
            animationPreference,
        } as MailLayoutOptions);
    }

    // Update store

    if (animationPreference == 0) {
        mediaQueryList.addListener(handleMotionPreferenceChange);
        setShouldAnimateMutator(mediaQueryList.matches);
        /* eslint-disable-next-line owa-custom-rules/allow-one-mutator-per-sync-scope -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, add a justification or fix the error.
         *	> It is not allowed to have multiple mutator calls within the same sync scope, combine the mutators into one to avoid unnecessary re-renders. */
        setAnimationPreferenceMutator(animationPreference);
    } else {
        if (getStore().animationPreference == 0) {
            mediaQueryList.removeListener(handleMotionPreferenceChange);
        }
        setShouldAnimateMutator(animationPreference == 1);
        /* eslint-disable-next-line owa-custom-rules/allow-one-mutator-per-sync-scope -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, add a justification or fix the error.
         *	> It is not allowed to have multiple mutator calls within the same sync scope, combine the mutators into one to avoid unnecessary re-renders. */
        setAnimationPreferenceMutator(animationPreference);
    }
}

function handleMotionPreferenceChange(this: MediaQueryList) {
    if (this.matches != getStore().shouldAnimate) {
        setShouldAnimateMutator(this.matches);
    }
}
